<script>
import api from "@/api";

export default {
  name: "MeasureGraphContainer",
  props: { id: { type: [Number, String] } },
  data() {
    return {
      measure: null,
      series: [],
    };
  },
  async created() {
    this.measure = await api.measures.find(this.id).then((data) => data);
    const { series } = await api.measures
      .getSeries(this.id)
      .then((data) => data);
    if (series.length > 0) {
      this.series = series[0].values;
    }
  },
  methods: {
    generateDataset() {
      let result = [];
      if (this.series.length === 0) return result;

      this.measure.graph_configs
        .filter((c) => c.visible)
        .map((c) => {
          result.push({
            x: this.generateXAxis(),
            y: this.generateYAxis(c.key),
            yaxis: c.yaxis,
            mode: c.mode,
            name: c.name,
            line: { dash: c.line },
            type: "scatter",
          });
        });

      return result;
    },
    getConfigBy(key) {
      return this.measure.graph_configs.find((c) => c.key === key);
    },
    generateXAxis() {
      return this.series.map((v) => v["time"]);
    },
    generateYAxis(key) {
      const config = this.getConfigBy(key);
      return this.series.map((v) => {
        return round(v[key] / config.coeff - config.offset, 2);
      });
    },
    updateGraphOffset(measure, event) {
      event.points.forEach(({ data, y }) => {
        if (data.yaxis === "y") {
          this.updateGraphConfigBy(data.name, y);
        }
      });
    },
    updateGraphConfigBy(name, value) {
      let index = this.measure.graph_configs.findIndex((c) => c.name === name);

      if (index > -1) {
        this.measure.graph_configs[index]["offset"] = value;
      }
    },
    saveGraphConfigs(measure) {
      const updateParams = measure.graph_configs.map((gc) => {
        let result = {};
        ["id", "name", "coeff", "offset", "visible"].forEach(
          (key) => (result[key] = gc[key])
        );

        return result;
      });

      measure.threshold.enabled = measure.notification.enabled;

      api.updateNotification(measure.id, measure.notification);
      api.measures.updateGraphConfigs(measure.id, updateParams);
      api.measures.updateThreshold(measure.id, measure.threshold);
      api.measures.update(measure.id, { yaxis_unit: measure.yaxis_unit });
    },
    generateShapes() {
      if (!this.measure) return [];
      if (this.measure.template_type === "axial_load") {
        let result = [];

        const threshold = this.measure.threshold;

        if (threshold.primary > 0) {
          result.push(this.createShape("dot", this.measure.threshold.primary));
        }

        if (threshold.secondary > 0) {
          result.push(
            this.createShape("dash", this.measure.threshold.secondary)
          );
        }

        if (threshold.tertiary > 0) {
          result.push(
            this.createShape("line", this.measure.threshold.tertiary)
          );
        }

        return result;
      }

      return [];
    },
    createShape(type, value) {
      return {
        type: "line",
        xref: "paper",
        x0: 0,
        y0: value,
        x1: 1,
        y1: value,
        line: {
          color: "rgb(255, 0, 0)",
          width: 2,
          dash: type,
        },
      };
    },
  },
  render() {
    return this.$scopedSlots.default({
      measure: this.measure,
      dataset: this.generateDataset(),
      updateGraphOffset: this.updateGraphOffset,
      saveGraphConfigs: this.saveGraphConfigs,
      shapes: this.generateShapes(),
    });
  },
};

function round(number, precision) {
  var shift = function(number, precision, reverseShift) {
    if (reverseShift) {
      precision = -precision;
    }
    var numArray = ("" + number).split("e");
    return +(
      numArray[0] +
      "e" +
      (numArray[1] ? +numArray[1] + precision : precision)
    );
  };
  return shift(Math.round(shift(number, precision, false)), precision, true);
}
</script>
